import {LanguageDtoFragment} from "../../../_gql/graphql";
import {Menu} from "@mantine/core";
import {Link} from "react-router-dom";
import React from "react";

export const ContextLanguageMenu = ({language}: { language: LanguageDtoFragment }) => {
    return <Menu.Dropdown>
        <Menu.Item component={Link} to={'/tree/lang/' + language.code}>Browse unpublished publications</Menu.Item>
    </Menu.Dropdown>
}